(() => {
  if (window.lgCardJourneyScene) return;
  const connections = new Map();
  function connect(journey) {
    const section = journey.closest('.shopify-section');
    const main = section?.previousElementSibling;
    const hero = main?.querySelector('.lg-hero-wrap');
    const art = hero?.querySelector('.lg-campaign-art');
    if (!hero || !art || !art.querySelector(':scope > picture')) return;
    const root = hero.closest('[data-lg-section]');
    let frame = 0;
    const update = () => {
      frame = 0;
      const top = hero.getBoundingClientRect().top;
      const height = journey.getBoundingClientRect().bottom - top;
      const offset = art.getBoundingClientRect().top - top;
      hero.style.setProperty('--lg-journey-scene-height', `${height}px`);
      hero.style.setProperty('--lg-journey-art-offset', `${offset}px`);
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(update);
    };
    hero.classList.add('lg-hero-wrap--journey');
    root?.classList.add('lg-card-main--journey');
    journey.classList.add('lg-journey--connected');
    update();
    const observer = new ResizeObserver(schedule);
    observer.observe(hero);
    observer.observe(journey);
    window.addEventListener('resize', schedule, { passive: true });
    connections.set(journey, () => {
      observer.disconnect();
      window.removeEventListener('resize', schedule);
      if (frame) cancelAnimationFrame(frame);
      hero.classList.remove('lg-hero-wrap--journey');
      root?.classList.remove('lg-card-main--journey');
      journey.classList.remove('lg-journey--connected');
      hero.style.removeProperty('--lg-journey-scene-height');
      hero.style.removeProperty('--lg-journey-art-offset');
    });
  }
  function refresh() {
    for (const disconnect of connections.values()) disconnect();
    connections.clear();
    document.querySelectorAll('.lg-journey').forEach(connect);
  }
  window.lgCardJourneyScene = { refresh };
  refresh();
  for (const event of ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder']) {
    document.addEventListener(event, () => requestAnimationFrame(refresh));
  }
})();
